import { UI_TEXT } from '@constants/ui-text';

const { PAGE_NOT_FOUND } = UI_TEXT;

const NotFound = () => {
    return <div>{PAGE_NOT_FOUND}</div>;
};

export default NotFound;
